import {
  Injectable,
  Optional,
} from '@angular/core';
import {
  Router,
} from '@angular/router';
import {
  FactsService,
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  AnalyticsService,
} from '@refx/analytics-core';
import {
  retrieveCurrentDate,
  retrieveCurrentDayOfTheWeek,
  retrieveCurrentHour,
  retrieveCurrentMinute,
  retrieveCurrentTimestamp,
  retrieveCurrentUTCDayOfTheWeek,
  retrieveCurrentUTCHour,
  retrieveCurrentUTCMinute,
  retrieveCurrentUTCTimestamp,
  retrieveDeviceType,
  retrieveLocationHref,
  retrieveLocationOrigin,
  retrieveLocationPathname,
  retrieveOperatingSystem,
  retrieveOperatingSystemVersion,
} from './fact-factories';
import {
  TechnicalDetailsFacts,
} from './technical-details.facts';

@Injectable()
export class TechnicalDetailsFactsService extends FactsService<TechnicalDetailsFacts> {
  private readonly currentDate = new Date();

  public facts = {
    currentHour: retrieveCurrentHour()(this.currentDate),
    currentUTCHour: retrieveCurrentUTCHour()(this.currentDate),
    currentMinute: retrieveCurrentMinute()(this.currentDate),
    currentUTCMinute: retrieveCurrentUTCMinute()(this.currentDate),
    currentDate: retrieveCurrentDate()(this.currentDate),
    currentTimestamp: retrieveCurrentTimestamp()(this.currentDate),
    currentUTCTimestamp: retrieveCurrentUTCTimestamp()(this.currentDate),
    currentDayOfTheWeek: retrieveCurrentDayOfTheWeek()(this.currentDate),
    currentUTCDayOfTheWeek: retrieveCurrentUTCDayOfTheWeek()(this.currentDate),
    operatingSystem: retrieveOperatingSystem()(this.analyticsService),
    operatingSystemVersion: retrieveOperatingSystemVersion()(this.analyticsService),
    deviceType: retrieveDeviceType()(this.analyticsService),
    locationHref: this.router.events.pipe(retrieveLocationHref()),
    locationOrigin: this.router.events.pipe(retrieveLocationOrigin()),
    locationPathname: this.router.events.pipe(retrieveLocationPathname())
  };

  constructor(
    rulesEngine: RulesEngineRunnerService,
    private readonly router: Router,
    @Optional() private readonly analyticsService?: AnalyticsService
  ) {
    super(rulesEngine);
  }
}
